import service from '@/services/superaccess'

const PermissionsModule = {
  state: {
    permissions: [],
    sections: JSON.parse(localStorage.getItem('sections')) || [],
    edit_permission: {},
    section_modal: false,
    permission_group_modal: false
  },
  mutations: {
    addPermissions (state, permission) {
      state.permissions = permission
    },
    addSections (state, section) {
      state.sections = section
      localStorage.setItem('sections', JSON.stringify(section))
    },
    updateStatePermission (state, data) {
      let permission = state.permissions.findIndex(p => p.id === data.permission_id)
      state.permissions[permission].state = data.state
    },
    editPermission (state, permission) {
      state.edit_permission = permission
    },
    updatePermissions (state, data) {
      let permission = {
        id: data.id,
        name: data.model.name,
        description: data.model.description,
        state: data.model.state,
        profiles: data.profiles
      }
      state.permissions.push(permission)
    },
    setStatusSectionModal (state, status) {
      state.section_modal = status
    },
    setStatusPermissionGroupModal (state, status) {
      state.permission_group_modal = status
    }
  },
  getters: {
    allPermissions (state) {
      return state.permissions
    },
    allSections (state) {
      return state.sections
    },
    getIdEditPermission (state) {
      return state.edit_permission
    },
    activatePermissions (state) {
      let result = []
      if (state.permissions.length > 0) {
        state.permissions.forEach(element => {
          if (element.state === 1) {
            result.push(element)
          }
        })
      }
      return result
    },
    getStatusSectionModal (state) {
      return state.section_modal
    },
    getStatusPermissionGroupModal (state) {
      return state.permission_group_modal
    }
  },
  actions: {
    retrieveActivePermissions (context, payload) {
      return service.post('/api/permission/all', context)
    },
    retrieveActiveGroupPermissions (context, payload) {
      return service.post('/api/permission-group/all', context)
    },
    permissions (state, language) {
      return new Promise((resolve, reject) => {
        service.post('/api/permission/all', state, {params: { language }}).then((result) => {
          state.commit('addPermissions', result.data)
        }, error => {
          console.log(error)
        })
      })
    },
    savePermission (state, data) {
      return new Promise((resolve, reject) => {
        service.post('/api/permission/create', state, { permission: data }).then((result) => {
          resolve(true)
        }, error => {
          reject(error)
        })
      })
    },
    editPermission (commit, data) {
      return new Promise((resolve, reject) => {
        service.patch('/api/permission/modify/' + data.id, commit, { permission: data })
          .then((result) => {
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    addProfilesToPermission (commit, data) {
      return new Promise((resolve, reject) => {
        service.post('/api/permission-profile/create', commit, { profiles_permission: data, isProfile: false })
      })
    },
    updateStatePermission (state, permission) {
      return service.get('/api/permission/change/' + permission, state)
    },
    changePermissionGroupState (context, payload) {
      return service.patch('/api/permission-group/change', context, payload)
    },
    detailsPermission (context, payload) {
      return service.get(`/api/permission/${payload}`, context)
    },
    sections (state) {
      return new Promise((resolve, reject) => {
        service.get('/api/section/all', state).then((result) => {
          state.commit('addSections', result.data)
          resolve(true)
        }, error => {
          console.log(error)
        })
      })
    },
    saveSection (state, data) {
      return service.post('/api/section/create', state, { section: data })
    },
    modifySection (state, data) {
      return service.post('/api/section/modify', state, { section: data })
    },
    updateStateSectionModal (context, payload) {
      context.commit('setStatusSectionModal', payload)
    },
    updateStateSection (context, payload) {
      return service.post('/api/section/change', context, payload)
    },
    updateStatePermissionGroupModal (context, payload) {
      context.commit('setStatusPermissionGroupModal', payload)
    },
    savePermissionGroup (state, data) {
      return service.post('/api/permission-group/create', state, { group: data })
    },
    modifyPermissionGroup (state, data) {
      return service.post('/api/permission-group/modify', state, { group: data })
    }
  }
}

export default PermissionsModule



// WEBPACK FOOTER //
// app/javascript/src/store/permissions.js